(function($){
  if( $(".SiteHeader-search_button")[1] ){
    var button = $(".SiteHeader-search_button")[1];
    $(".SiteHeader-search_button").wrapInner('<span>Search</span>');
    button.classList.add("Basic-button", "SearchResults-search_button");
  }
})(jQuery);
